import React from 'react'
import PreviousIcon from 'svg/left-caret.svg'
import NextIcon from 'svg/right-caret.svg'
import styles from './Pagination.module.scss'
import SALink from 'components/SALink'
import classNames from 'classnames'

type PaginationMobileButtonProps = {
  direction: 'back' | 'next'
  pageNumber: number | null
  onClickChangePage: (page: number) => (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  getUrlWithParam: ({ page }: { page: number }) => string
  disabled?: boolean
  isIconVisible?: boolean
  isNextBackVisibleOnMobile?: boolean
  isMobileStyle?: boolean
}

const PaginationMobileButton = ({
  direction,
  pageNumber,
  onClickChangePage,
  getUrlWithParam,
  disabled,
  isIconVisible = true,
  isNextBackVisibleOnMobile = true,
  isMobileStyle = true,
}: PaginationMobileButtonProps) => {
  const isBackButton = direction === 'back'
  const IconComponent = isBackButton ? <PreviousIcon /> : <NextIcon />
  const Icon = isIconVisible ? IconComponent : null

  return (
    <button
      className={classNames(styles.paginationButton, {
        [styles.showBack]: isBackButton && isMobileStyle,
        [styles.showNext]: !isBackButton && isMobileStyle,
        [styles.paginationButtonHidden]: !isNextBackVisibleOnMobile,
      })}
      disabled={disabled}
    >
      <SALink
        href={pageNumber ? getUrlWithParam({ page: pageNumber }) : undefined}
        onClick={pageNumber ? onClickChangePage(pageNumber) : undefined}
        rel={pageNumber ? 'follow' : 'nofollow'}
        data-value={pageNumber}
        aria-label={`Go to ${isBackButton ? 'previous' : 'next'} page`}
        title={isBackButton ? 'Previous' : 'Next'}
      >
        <p
          className={classNames({
            [styles.pageLinkHidden]: !isMobileStyle,
            [styles.buttonText]: isMobileStyle,
            [styles.isBackText]: isBackButton,
          })}
        >
          {isBackButton ? 'Back' : 'Next'}
        </p>
        {Icon}
      </SALink>
    </button>
  )
}

export default PaginationMobileButton
